var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee typo--title-big",class:[_vm.data.settings.bg_color]},[_c('MarqueeText',{attrs:{"repeat":6}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.madText(_vm.data.value.text.trim())+'&puncsp;')}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }